import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { FileSchema } from "../../Schemas/File";

interface FileUrlParams {
  workspaceId: number;
}

export interface FileUploadResponseBody extends IResponseBody {
  data: {
    file: FileSchema;
  };
}

export class FileUploadRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(fileUrlParams: FileUrlParams) {
    return `/panel/workspace/${fileUrlParams.workspaceId}/files/upload-audio`;
  }

  async send(
    fileUrlParams: FileUrlParams,
    fileFormData: FormData
  ): Promise<FileUploadResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(fileUrlParams),
        fileFormData
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
